module.exports = {
    all:{
        'application': '活动申请',
        'Pleaseenjoy': '请根据活动条件填写您能享受赠送的金额',
        'Fillamount': '填写申请金额（非必填）',
        'Applynow': '立即申请',

        'howtoplay': '玩法',
        'playContent': '内容',
        
    },
    header: {
        'home': '首页',
        'boardgame': '棋牌游戏',
        'electronicgames': '电子游艺',
        'livevideo': '真人视讯',
        'eSportsbattle': '电竞对战',
        'lotterybetting': '彩票投注',
        'sportingevents': '体育赛事',
        'Promotions': '优惠活动',
        'Entitybrand': '实体品牌',
        'onlinebrand': '线上品牌',
        'specialized': '专业博彩运营平台',
        'Proxylogin': '代理登录',
        'Regularlicense': '正规牌照',
        'borrow': '借呗',
        'YueBao': '余额宝',
        'Login': '登录',
        'register': '注册',
        'Signout': '登出',
        'nohaveTost': '近期上线，敬请期待！',
        'Notmember': '还不是会员？',
        'review': '审核状态查看',
        'Alloffers': '全部优惠',

    },
    foot: {
        'contactus': '联系我们',
        'Strive': '竭力为您提供优质服务',
        'hAgentome': '代理加盟',
        'Let': '让我们携手共创美好未来',
        'Join': '加盟咨询',
        'security': '安全保障',
        'Professional': '专业博彩运营平台',
        'Gaming': '博彩牌照',
        'Hold': '持有 Pagcor 合法执照',
        'View': '立即查看',
        'about': '关于我们',
        'contact': '联系方式',
        'Agents': '代理加盟',
        'Disclaimer': '免责声明',
        'Privacy': '隐私政策',
        'common': '常见问题',
        'game': '博彩责任',
        'All': '版权所有',
        'kefgu': ' 24小时在线客服',
        'actual': ' 真实姓名',
        'real': ' 请输入您的真实姓名',
        'number': ' 联系电话',
        'enterqq': ' 请输入您的联系电话',
        'Reason': ' 申请理由',
        'enter': ' 请输入您的申请理由',
        'Applications': ' 申请加入',
        'correct': ' 申请输入正确手机号',
        'enters': ' 请输入申请理由',
    },
    app: {
        'loading': '加载中..',
        'sure': '您确定要退出登录吗',
        'hint': '提示',
        'Yes': '是的',
        'No': '点错了',
        'Linking': '正在链接人工客服',
        'Already': '已在当前页面！',
        'Red': '红包已关闭',

        'delete': '请先删除旧版APP再重新安装',
        'iOS': 'iOS 用户请使用 Safari 浏览器开启页面下载',
        'Scan': '扫码下载APP',
        'Direct': '无需下载直接访问',
        'Installation': '安装教程',
        'Download': '须在同一网络环境下下载安装和注册，勿切换网络，',
        'cannot': '若无法正常下载，请使用手机浏览器开启。',
        'ios1': '1. 扫码后于页面中点选【立即下载】',
        'ios2': '2. 点选【允许】',
        'ios3': '3. 点选【关闭】后进入设定',
        'ios4': '4. 点选描述文件安装',
        'ios5': '5. 点选【安装】',
        'ios6': '6. 【允许】网站配置描述文件',
        'ios7': '7. 点选【安装】即可成功安装、尽情游玩',
        'adr1': '1. 扫码后于页面中点选【立即下载】',
        'adr2': '2【允许】浏览器访问您的设备',
        'adr3': '3. 点选【下载】',
        'adr4': '4. 当下载完成后选择档案',
        'adr5': '5. 点选【设置】',
        'adr6': '6. 允许您的设备安装应用程序',


    },
    main: {
        'amount': '请输入操作金额！',
        'wallet': '平台钱包',
        'operation': '操作成功！',
        'withdrawal': '单笔取款不能低于100元！',
        'select': '请选择您要提现到的银行卡！',
        'enter': '请输入您的支付密码！',
        'successfully': '提交成功，等待后台审核！',
        'address': '请选择USDT地址!',
        'name': '请输入存款人姓名!',
        'type': '请输入银行类型!',
        'number': '请输入银行卡号!',
        'account': '请输入银行开户行地址!',
        'correct': '请输入正确金额!',
        'Jumping': '正在跳转...',
        'going': '正在前往页面',
        'open': '正在前往打开游戏页面!',
        'Copy': '复制成功！',
        'correctamount': '请输入正确金额!',
    },
    register: {
        'registerWelcome': '欢迎加入！',
        'joinin': '加入',
        'Entertainment': '娱乐平台，拥有独一无二的会员账号价值：',
        'maximum1': '1.首存最高可享9999元返现，注册后即可享受！',
        'maximum2': '2、不定期最高返利1元起3.0%，更多棋牌电子优惠等你来拿！',
        'maximum3': '3、充值游戏天天享受：【充值天天送，月返现】！',
        'maximum4': '享受业内最豪华的视频游戏套餐！',
        'maximum5': '详情请点击右上角【最新优惠】查看！',
        'Signup': '注册一个帐户',
        'account': '登录账号：',
        'number': '帐号（最少6位，英文及数字）',
        'password': '登录密码：',
        'minimumPassword': '密码（最少8位，英文及数字）',
        'Confirm': '确认密码：',
        'confirmconfirm': '请确认您的密码',
        'Member': '会员简介',
        'actual': '真实姓名：',
        'real': '请输入您的真实姓名',
        'Withdrawals': '取款密码：',
        'withdrawal': '请输入6位取款密码',
        'code': '验 证 码 :',
        'verification': '请输入您的验证码',
        'confirmthat': '我确认所填信息属实，本人年满18周岁，已阅读并接受',
        'Agreement': '相关条款和隐私协议',
        'submit': '提交',
        'havean': '有账号，',
        'hint': '提示：',
        'bring': '带',
        'required': '的项目为必填项。',
        'proof': '提现密码是提现金额的证明，请记得填写密码。',
        'other': '温馨提示：如果您在注册过程中遇到同名或无法注册等其他问题，请联系在线客服，我们会尽快为您解决！',
        'read': '请阅读并同意相关条款和隐私协议！',
        'Username': '用户名长度不得低于6位，以字母和数字组合！',
        'Password': '密码长度最少8位！以字母和数字组合！',
        'match': '两次密码不一致！',
        'formatname': '姓名格式不正确，可以是中，英文名称！',
        'length': '支付密码长度需是6位！',
        'codeerror': '验证码错误！',
    },
    login: {
        'tologin': '会员登录，欢迎登录！',
        'usernameas': '用户名：',
        'usernameA': '请输入您的用户名！',
        'passwordS': '密码：',
        'pleasepassword': '请输入您的密码!',
        'verification': '验证码',
        'verificationCS': '请输入验证码!',
        'Noaccount': '没有账号，',
        'Verificationerror': '验证码错误！',
        'blacklist': '您已被设为黑名单，暂不能登录，请联系管理员！',
        'stop': '该用户已被禁用，请联系管理员！',
    }
    ,
    index: {
        'Welcome': '欢迎来到',
        'Latest': '最新公告',
        'VIP': 'VIP专属',
        'Quick': '快速充值',
        'Discount': '优惠大厅',
        'Deposit': '1.2% 存款折扣，3.0% 最高返利',
        'Comprehensive': '综合游戏区',
        'beauty': '美女主播',
        'Games': '游戏和娱乐',
        'Exclusive': '独家经销商大收藏',
        'Experience': '体验欧式美女',
        'players': '20,000 在线玩家',
        'baccarat': '唯一的百家乐',
        'have': '尽情享受欢乐',
        'beautiful': '漂亮的主播',
        'play': '玩新OG',
        'most': '最受欢迎',
        'Classic': '经典玩法',
        'Preferred': '土豪首选',
        'extreme': '极致图片',
        'surprise': '惊奇',
        'Gamess': '游戏体验',
        'visual': '3D视觉盛宴',
        'levels': '更多关卡',
        'rich': '丰富的玩法',
        'high': '高频彩票',
        'Diversified': '多样化的玩法',
        'richest': '亚洲最富有的盛会',
        'fast': '快速结算',
        'top': '全球顶级娱乐平台一应俱全',
        'complete': '全网最全的棋牌类游戏，累积奖池1亿元，大奖在即！',
        'Kaiyuan': '开元棋牌',
        'New': '新世界棋牌',
        'FG': 'FG棋牌',
        'VG': 'VG棋牌',
        'More': '更多',
        'chess': '全网最全的棋牌类游戏，累积奖池1亿元，大奖在即！',
        'Dynasty': '皇朝电子',
        'HB': 'HB电子',
        'PG': 'PG电子',
        'PP': 'PP电子',
        'Indiana': '夺宝电子',
        'Quality': '品质服务 极致体验',
        'Authorized': '澳门特别行政区政府授权',
        'Government': '欧洲王国政府授权',
        'Isle': '英国曼岛政府授权',
        'Republic': '亚洲菲律宾共和国政府授权',
        'announcement': '公告',
        'official': '★★★官方平台运营商服务商定期，请您对TG入账款概入账款我司查看最新入账！不负责付账！请给您的每次入账费用！请查看最新的银行入账款。 ',
        'playgames': '玩游戏',
        'allgames': '所有游戏',
        'obz': 'OB电子',
        'fgz': 'FG电子',
        'ppz': 'PP电子',
        'aez': 'AE电子',
        'pgz': 'PG电子',
        'fgfish': 'FG捕鱼',
        'TFdz': 'TF电竞官网是中国专业电竞竞猜平台商，提供王者荣耀竞猜、英雄联盟竞猜、DOTA2竞猜、CSGO竞猜直播、电竞热门视频及最新电竞资讯等服务。',
        'fydz': '泛亚电竞是菲律宾产业集团旗下产品，全球竞猜系统供应商，提供英雄联盟，DOTA2，CSGO等电竞服务。',
        'obdz': 'OB电竞，几万种电竞赛选项；拥有行业领先的竞赛成果结算速度。',
        'aidz': '每月提供20个电竞赛事，2000年，几万种电竞赛选项；拥有行业领先的竞赛成果结算速度。',
        'activity': '活动详情',
        'Event': '活动条款与规则',
        'How': '申请方式',
        'Eligible': '符合条件的会员请于当月申请，逾期则视为放弃！',
        'Please': '请在下方填写您的申请信息',
        'member': '会员账号',
        'fill': '请正确填写您的会员账号',
        'will': '提交后将在30分钟内为您处理，查看',
        'Audit': '【审核进度】',
        'thanks': '，谢谢！',
        'application': '提交申请',
    },
    mine: {
        // 
        'welcome2': '，欢迎',
        'Financial': '金融中心',
        'Loan': '我的贷款',
        'interest': '我的兴趣',
        'Center': '会员中心',
        'soon': '即将上线，敬请期待！！',

        
        'qihao': '期号',
        'Quota': '配额转换',
        'transfermode': '转账模式',
        'Spin': '免转模式',
        'refresh': '刷新',
        'recycling': '一键回收',
        'Click': '点击 [刷新] 更新余额数据',
        'Account': '账户余额',
        'balance': '游戏余额',
        'titransfert': '转移方式',
        'transferin': '转入',
        'transferout': '转出',
        'Action': '操作金额',
        'Fill': '填写金额',
        'confirm': '确认',
        'Platform': '平台钱包',
        'operation': '请输入操作金额！',
        'Successful': '操作成功！',


        'osit': '存款',
        'Select': '选择付款方式',
        'Bank': '银行卡',
        'USDT': 'USDT',
        'Alipay': '支付宝',
        'WeChat': '微信',
        'Manual': '人工充值',
        'Submission': '充值提交',
        'Payment': '支付方式：',
        'information': '收款银行信息',
        'Payments': '收款账号：',
        'Copy': '复制',
        'AccountName': '帐户名称：',
        'Bankdeposit': '开户银行：',
        'BankAddress': '银行地址：',
        'PaymentInformation': '支付信息',
        'AccountNamea': '帐户名称：',

        'SelectBank': '选择银行类型',
        'selectsupporting': '请选择支持银行',
        'PayerName': '付款人姓名',
        'fillname': '请填写付款人姓名',
        'Banknumber': '银行卡号',
        'fillcard': '请填写付款人银行卡号',
        'opening': '开户行地址',
        'address': '请填写开户行地址',
        'Recharge': '充值金额',
        'enterwithdrawal': '请输入取款金额',
        'Submit': '提交',
        'measures': '预防措施',
        'Before': '1. 每次存款前，请到此页面查看最新收款账户。',
        'funds': '请勿自行将资金存入旧账户。',
        'into': '如存入旧账户，本公司将无法查核，概不负责。',
        'Please2': '2.请尽量在同一家银行存款。',
        'areanother': '如果您在其他银行，请尽快到账，以方便系统加快您的入金速度。',
        'wallet': '选择钱包类型',
        'supported': '请选择支持的钱包类型',
        'arrival': '实际到账',
        'exchange': '参考汇率：',
        'Human': '人工服务',
        'Contact': '联系人工客服',
        'reminder': '温馨提示',
        'also': '您还未绑定钱包卡片，请前往添加！',
        'binding': '前往绑定',
        'enterdepositor': '请输入存款人姓名',
        'enterbank': '请输入银行类型',
        'enterbanks': '请输入银行卡号',
        'enteraccount': '请输入银行开户行地址',
        'enteramount': '请输入金额在',
        'SuccBetweenessful': '之间！',
        'Submitted': '提交成功，等待后台审核',
        'Jumping': '正在跳转...',
        'Copysuccessfully': '复制成功！',
        // 取款
        'Withdrawal1': '取款',
        'Addaccount1': '添加账户',
        'bankpayment1': '前往绑定银行卡收款',
        'USDTpayment1': '前往绑定USDT地址收款',
        'Receiving1': '收款账户',
        'Receiving12': '请选择收款账户',
        'Accountbalance1': '账户余额',
        'Codesize1': '打码量',
        'Withdrawalamount1': '取款金额',
        'enterwithdrawal1': '请输入取款金额',
        'password1': '取款密码',
        'enterpassword1': '请输入提现密码',
        'transaction1': '每笔手续费',
        'USDTconversion1': 'USDT换算',
        'questions1': '如果您有任何问题，请联系',
        'Online1': '在线服务',
        'Apply1': '申请提款',
        'measures1': '预防措施',
        'platforms1': '温馨提示：有余额的游戏平台因平台政策因素，可能无法将余额全部退回主钱包。',
        'limit1': '今日取款限额：剩余99999999.00元/合计99999999.00元今天取款次数：剩余999999/合计999999取款金额必须大于取款手续费才能取款。 ',
        'supporting1': '请选择支持银行',
        'opening1': '填写开户行',
        'enteropening1': '请输入开户行',
        'cardnumber1': '填写卡号',
        'cardholder1': '填写持卡人姓名',
        'Paymentpassword1': '支付密码',
        'Binding1': '绑定',
        'wallet1': '请选择钱包协议',
        'USDTaddress1': '填写USDT地址',
        'enterUSDTaddress1': '请输入USDT地址',
        'osenterpaymentpasswordit1': '请输人支付密码',
        'entername1': '请输入姓名',
        'enterthebank1': '请输入银行',
        'enteraddress1': '请输入开户行地址',
        'enterbanknumber1': '请输人银行卡号',
        'enterpaymentpassword1': '请输人支付密码',
        'correctlength1': '请输人正确的卡号长度',
        'enterofpassword1': '请输人支付密码长度',
        'Bindingsuccessful1': '绑定成功',
        'singlecannot1': '单笔取款不能低于100元',
        'bankwithdrawto1': '请选择您要提现到的银行卡',
        'paymentpassword1': '请输入您的支付密码',
        'successfullywaiting1': '提交成功，等待后台审核',
        'selectUSDTaddress1': '请选择USDT地址',
        // 银行卡 钱包管理
        'management': '卡包管理',
        'Managementaa': '管理',
        'Clickbank': '点击添加银行卡',
        'ClickUSDT': '点击添加USDT地址',
        'Unbinding': '解绑',
        'BankName': '银行名称',
        'BankHead': '银行户主',
        'Accountaddress': '开户地址',
        'Wallettype': '钱包类型',
        'Walletaddress': '钱包地址',
        'Walletprotocol': '钱包协议',
        'Reminder': '温馨提示：每个账户只能绑定5张银行卡/USDT钱包，如若修改请删除后重新添加！',
        'Arewant': '确定要解绑吗？',
        'Unbindingsucceeded': '解绑成功',
        

        'Transactionhistory': '交易记录',
        'BetHistory': '投注记录',
        'Rebaterecord': '返水记录',
        'applicationrecord': '活动申请记录',
        'Proxyapplication': '代理申请',
        'Redenvelope': '红包',
        'Personalinformation': '个人信息',
        'MessageCenter': '消息中心',
        'Internalmessage': '站内信',
        'Announcement': '公告',


        'Improving2': '改善个人信息可以提高账户安全性。真实姓名设置好后只能联系客服修改。请认真填写！',
        'Contact2': '联系客服',
        'Username2': '用户名',
        'realname2': '真正的名字',
        'Birthdate2': '出生日期',
        'Mailbox2': '邮箱',
        'Mobilenumber2': '手机号',
        'Confirmation2': '确认',
        'SecurityCenter2': '安全中心',
        'Modifylogin2': '修改登录密码',
        'loginbeen2': '登录密码已设置，再次设置即可修改登录密码',
        'Modify2': '修改',
        'Changesecurity2': '更改安全密码',
        'securitybeen2': '已设置安全密码，再次设置可修改安全密码',
        'alreadyapplied2': '如已申请，请勿重复申请',
        'enteroriginal2': '请输入原密码',
        'enternew2': '请输入新密码',
        'newenter2': '请重新输入新密码',
        'yourname2': '您的姓名',
        'enterreason2': '请输入申请理由',
        'enterphone2': '请输入正确手机号',
        'enterapplication2': '请输入申请理由',
        'enterold2': '请输入旧密码',
        'enternewpassword2': '请输入新密码',
        'enterpasswordlength2': '请输入正确的旧密码长度',
        'entercorrect2': '请输入正确的新密码长度',
        'enterconfirmation2': '请输入确认密码',
        'passwordstwo2': '两次密码不一致！',
        'oldnew2': '新旧密码不能一致！',
        'changed2': '密码修改成功！',
        'enterphoneenter2': '请输入正确手机号',
        'enteremail2': '请输入正确邮箱号',
        'entercorrect2w': '请输入正确的日期格式：YYYY-MM-DD',
 
        'platform': '选择平台',
        'Transactiontype': '交易类型',
        'Selectplatform': '选择平台',
        'Timerange': '时间范围',
        'today': '今日',
        'week': '一周内',
        'month': '半月内',
        'onemonth': '一月内',
        'number': '序号',
        'time': '时间',
        'Ordernumber': '订单号',
        'Transactiontypea': '交易类型',
        'Amount': '金额',
        'Status': '状态',
        'Nodata': '暂无数据',
        'undefined': '未定义',
        'reviewed': '待审核',
        'Approved': '审核通过',
        'Audit': '审核拒绝',
        'Failed': '失败',
        'success': '成功',
        'settled': '待结算',
        'platforms': '全平台',
        'Gamename': '游戏名称',
        'Payout': '派彩',
        'Invalidbet': '无效注单',
        'Payouts': '已结算',
        'Unpaid': '未结算',


        'Rebatestatus': '返水情况',
        'Accumulatedpayment': '累计领取',
        'Unpaidsdf': '待领取',
        'Received': '已领取',
        'Not': '暂未领取',
        'Receive': '领取',
        'Rebateamount': '返水金额',
        'Rebatetime': '返水时间',
        'Collectiontime': '领取时间',
        'Thereclaim': '暂无领取额度！',
        'ApplicationTime': '申请时间',
        'Applycontent': '申请优惠内容',
        'Auditresult': '审核结果',
        

        'Redsituation': '红包情况',
        'Accumulated': '累计领取次数',
        'Remaining': '剩余领取次数',
        'Receives': '领取红包',
        'Redenvelopes': '红包金额',
        'Rechargetimes': '充值时间',
        'havetrialss': '您的剩余次数不足！',
        'Servererrors': '服务器异常，请稍后再试!',

        'paymentss': '剩余支付时间',
        'Orderv': '订单编号',
        'Currentv': '当前汇率',
        'Rechargev': '充值数量',
        'Pleasev': '请注意：您的实际到账金额要与此金额完全一致，否则无法及时到账',
        'Pleaseva': '1. 请勿向上述地址充值任何非',
        'Assetva': '资产，否则资产将会丢失；',
        'Pleasevaa': '2. 请务必确认电脑及浏览器安全，防止信息被篡改或泄密。',
        'Afterv': '2. 向上述地址充值后，需要网络节点区块确认，链上网络确认后到账；',
        'Pleasevas': '3. 请务必确认电脑及浏览器安全，防止信息被篡改或泄密。',
        'Protocolv': '协议：请使用',
        'TRON': '波场链',
        'Ethereum': '以太坊链',
        'Protocol': '协议',
        'For': '进行交易 ，其他智能链充值造成的不到账，金额损失自己承担。',
        'Paymentvas': '已完成付款',

        
        
    }
    , vip: {
        'level': 'VIP等级',
        'conditions': '晋级条件',
        'water': '返水比例',
        'running': '累计流水',
        'recharge': '累计充值',

        'CASINO': '真人返水',
        'SLOTS': '电子返水',
        'CARD': '棋牌返水',
        'SPORTS': '体育返水',
        'LOTTERY': '彩票返水',
        'ESPORT': '电竞返水',

    },
    Redenvelope:{
        'Remaining': '剩余领取次数',
        'Received': '已领取',
        'bout': '次',
        'Currently': '当前最多可领取',
        'meet': '快去满足条件吧！',
        'activity': '活动时间',
        'amount': '累计充值金额',
        'Number': '红包次数',
        'Collection': '领取规则',
        'After': '1.抢到红包后，系统自动派彩，',
        'Second': '秒到账',
        'you': '，达到流水倍数即可取款；',
        'Conditions': '2.领取红包条件：充值金额需要在规定的活动日期（美东时间）范围内，根据充值累计金额，获取抢红包次数，即可抢对应次数的红包；',
        'Note': '注意：',
        'Grabred': '抢红包',
        'Beijing': '北京时间为每天早上 10点到12点，存款计算为前一天12点到今天10点，谢谢~',
        'Daily': '每日百万现金红包！存款越多，机会越多，红包享不停，惊喜抢不停，还等什么？快快叫上好友一起分享吧！！',
        'Members': '1、会员必须在指定的活动日期（美东时间）范围内，根据充值累计金额，即可获得对应抢红包次数。若在规定的时间范围内没有达到存款金额范围，则不计算抢红包次数，逾期作废！',
        'All': '2、所有的活动优惠特为玩家而设，如发现任何团体或个人，以不诚实的方式套取红利或任何威胁、滥用公司优惠等行为，公司保留冻结、取消该团体或个人账户及账户结余的权利。',
        'rights': '保留所有解释权，在任何时候都可以更改、停止、取消优惠活动。',
        'event': '活动还没开始，请静待活动开始。',
        'Please': '请静待下次活动。',
        'Congratulations': '恭喜您',
        'Grab': '抢到',
        'meta': '元',
        'Recharge': '立即充值',
        'met': '您暂未达到领取条件，快去完成吧！',
        'Server': '服务器异常，请稍后再试',

    }
}


// WEBPACK FOOTER //
// ./src/i18n/zh.js